<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="perfectLoading">
      <div class="search-top-row">
        <el-row>
          <el-col>
            <!-- <el-select v-model="perfectForm.isActive" size="small" placeholder="过期状态" clearable filterable>
                  <el-option v-for="(item, idx) in activeList" :key="idx" :value="item.id" :label="item.name" />
                </el-select>
                <el-select v-model="perfectForm.publishStatus" size="small" placeholder="禁用状态" clearable filterable>
                  <el-option v-for="(item, idx) in statusList" :key="idx" :value="item.id" :label="item.name" />
            </el-select>-->
            <el-select v-if="employeeLevel === 50" v-model="perfectForm.orgCode" size="small" placeholder="选择区域" clearable filterable>
              <el-option v-for="(item, idx) in orgList" :key="idx" :value="item.orgCode" :label="item.orgName" />
            </el-select>
            <el-select v-model="perfectForm.channelCode" size="small" placeholder="选择渠道" clearable filterable>
              <el-option v-for="(item, idx) in channelList" :key="idx" :value="item.key" :label="item.value" />
            </el-select>
            <el-input class="search-input" v-model="perfectForm.themeName" placeholder="主题名称">
              <i slot="suffix" class="el-input__icon el-icon-search noselect"></i>
            </el-input>
            <el-button class="btn-red" size="small" @click="getPerfectList()">搜索</el-button>
            <el-button class="btn-reset" size="small" @click="resetSearch()">重置</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <el-card v-for="item in perfectList" :key="item.themeCode" @click.native="jumpDetail(item)">
          <el-row>
            <el-col class="col-wrapper content-center" :span="2">
              <div class="status-img">
                <img v-if="currentTime > item.endDate" style="width:100%" src="../../../assets/images/expire-img.png" />
                <img v-else-if="item.publishStatus === 0" style="width:100%" src="../../../assets/images/disable-img.png" />
                <img v-else style="width:100%" src="../../../assets/images/active-img.png" />
              </div>
            </el-col>
            <el-col class="list-name col-wrapper" :span="7">
              <el-row>
                <div class="theme-name">{{ item.themeName}}</div>
              </el-row>
              <el-row>
                <div class="area-name">{{ item.orgName}}</div>
              </el-row>
            </el-col>
            <el-col class="col-wrapper content-center" :span="5">
              <div class="channel-name">{{ item.channelName }}</div>
            </el-col>
            <el-col class="col-wrapper content-center" :span="9">
              <div class="date-content">{{ item.startDate | parseDate }} - {{ item.endDate | parseDate }}</div>
            </el-col>
          </el-row>
        </el-card>
        <div class="pagination">
          <el-pagination
            background
            :current-page="perfectForm.page"
            :page-size="perfectForm.pageSize"
            :total="perfectTotal"
            layout="total, prev, pager, next"
            @current-change="handlePerfectChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      channelList: state => state.base.tradeStackThemeChannelMap
    })
  },
  data () {
    return {
      perfectList: [],
      perfectLoading: false,
      perfectForm: {
        themeName: '',
        orgCode: '',
        channelCode: '',
        page: 1,
        pageSize: 10
      },
      perfectTotal: 2,
      employeeLevel: '',
      orgList: '',
      activeList: [
        { id: '0', name: '已过期' },
        { id: '1', name: '生效中' }
      ],
      statusList: [
        { id: '0', name: '已禁用' },
        { id: '1', name: '已启用' }
      ],
      currentTime: new Date().getTime()
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.$store.dispatch('getDictByName', 'tradeStackThemeChannelMap')
    this.getPerfectList()
    this.getOrgList()
  },
  methods: {
    // 完美门店
    getPerfectList () {
      this.perfectLoading = true
      tradeApi.getPerfectHistoryList(this.perfectForm).then(res => {
        if (res.data.resultCode === '0') {
          this.perfectLoading = false
          this.perfectList = res.data.resultData.tradePerfectThemeDefineList
          this.perfectTotal = res.data.resultData.pageInfo.totalCounts
        }
      })
    },
    handlePerfectChange (val) {
      this.perfectForm.page = val
      this.getPerfectList()
    },
    // 获取区域
    getOrgList () {
      this.$store
        .dispatch('areaList')
        .then(res => {
          if (res.data.resultCode === '0') {
            if (this.employeeLevel === 50) {
              this.orgList = res.data.resultData.regionList || []
            }
            if (this.employeeLevel === 60) {
              this.orgList = res.data.resultData.buList || []
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    jumpDetail (row) {
      console.log(row)
      if (this.employeeLevel === 60) {
        this.$router.push({ name: 'perfect-bu-view', query: { themeDefineId: row.themeDefineId, type: 'view' } })
      } else {
        this.$router.push({
          path: '/perfect-region-history-detail',
          query: { themeDefineId: row.themeDefineId }
        })
      }
    },
    // 重置
    resetSearch () {
      this.perfectForm = this.$options.data().perfectForm
    }
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  width: 900px;
  ::v-deep .el-tabs__header {
    width: 130px;
    background-color: #fff;
    text-align: center;
  }
  ::v-deep .el-tabs__item {
    width: 130px;
    height: 50px;
    font-size: 14px;
    font-weight: 700;
    line-height: 50px;
    padding: 0;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #fff;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #c8102d;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #c8102d;
  }
  ::v-deep .el-tabs__item:hover {
    color: #c8102d;
  }
}
.col-wrapper {
  text-align: center;
  height: 60px;
}
.el-card {
  height: 100px;
  margin: 0 auto 20px;
  padding: 0 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.content-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-img {
  width: 50px;
  height: 50px;
}
.list-name {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 0;
}
.theme-name {
  font-size: 18px;
  font-weight: 600;
}
.channel-name {
  font-size: 15px;
  font-weight: 600;
}
.area-name {
  font-size: 12px;
  color: #7f7f7f;
}
.theme-name,
.area-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 5px;
}
.date-content {
  font-size: 14px;
  color: #7f7f7f;
}
.col-wraper {
  text-align: center;
  height: 60px;
}
.pagination {
  text-align: center;
}
.search-input.el-input {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.search-input {
  .el-input__icon {
    line-height: 32px;
  }
  ::v-deep .el-input__inner {
    height: 32px;
    border-radius: 5px;
  }
}

.el-select {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
}
</style>
